import * as types from '../mutation-types'
import * as consts from '../../data/base/consts'
import { API } from '../../api';
import { FATE_DATA_MANAGER } from '../../data';

export default {
    namespaced: true,
    state: {
        gotSettingData: false,
        settingConfigData: {},
        curShowType: 1,
        mySetFateInfo: {},
        mySetFateListData: [],
        mySetFateSideListData: [],
    },
    getters: {},
    mutations: {
    },
    actions: {
        initSettingData({ dispatch, state }) {
            if(state.gotSettingData) { return }
            API.getSettingConfig({}, function(data){
                console.log('获取基础配置信息::::::', data);
                state.gotSettingData = true;
                state.settingConfigData = data;
                console.log('settingConfigData:::::::', state.settingConfigData);
                state.curShowType = parseInt(data.showShiShenGZ);
                // 设置流运显示格式
                AppFate.$store.state.detail.fatefortune.showTable = parseInt(data.liuYunCount) == 0 ? 5 : 10;
            });
        },
        toggleSetHideTypes({ dispatch, state }) {
            var typeList = consts.CONST_SHISHEN_SHOW_TYPES;
            if(state.curShowType == (typeList.length - 1)) {
                state.curShowType = 0;
            }else{
                state.curShowType += 1;
            }
            // 上传更新
            dispatch('updateSettingData', {
                params: {
                    'showShiShenGZ': state.curShowType
                }
            });
        },
        initSettingUIData({state}, params) {
            var detailInfo = params && params.detailInfo && params.detailInfo.id ? params.detailInfo : null;
            var result = FATE_DATA_MANAGER.getCurrentTimeFateListData(detailInfo);
            state.mySetFateInfo = detailInfo ? detailInfo : {sex: 0};
            state.mySetFateListData = result.fateListData;
            state.mySetFateSideListData = result.fateSideListData.slice(0, 3);
            console.log('initSettingUIData------', result)
        },
        /**
         * 修改设置数据
         * @param {修改内容的key和value} params 
         */
        updateSettingData({ state }, params) {
            API.updateSettingConfig(params.params, function(data) {
                console.log('修改设置数据成功:::::::', data)
                // 更新本地数据
                for(var keys in params.params) {
                    state.settingConfigData[keys] = data[keys];
                }

                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
            })
        },
        resetData({ state }) {
            state.gotSettingData = false;
            state.settingConfigData = {};
            state.curShowType = 1;
            state.mySetFateListData = [];
            state.mySetFateSideListData = [];
        }
    }
}